// src/admin/AdminOrderDetail.jsx
import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';

const STATUSES = ['pending', 'confirmed', 'prepared', 'shipped', 'delivered', 'cancelled'];
const STATUS_LABELS = {
  pending:   'En attente',
  confirmed: 'Confirmée',
  prepared:  'Préparée',
  shipped:   'Expédiée',
  delivered: 'Livrée',
  cancelled: 'Annulée',
};

function AdminOrderDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem('auth_token');
    axios.get(`https://madadline.com/api/orders/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(({ data }) => setOrder(data))
      .catch(() => setOrder(null))
      .finally(() => setLoading(false));
  }, [id]);

  const updateStatus = async (newStatus) => {
    if (!window.confirm(`Changer le statut en "${STATUS_LABELS[newStatus]}" ?`)) return;
    setSaving(true);
    try {
      const token = localStorage.getItem('auth_token');
      await axios.put(`https://madadline.com/api/orders/${id}`, { status: newStatus }, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setOrder(prev => ({ ...prev, status: newStatus }));
    } catch (e) {
      alert('Erreur lors de la mise à jour.');
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <div className="admin-loading"><div className="spinner" /></div>;
  if (!order) return <div className="admin-empty">Commande introuvable.</div>;

  const items = order.items || order.cart_items || [];

  return (
    <div className="admin-order-detail">

      <header className="admin-page-head">
        <div>
          <h1>Commande #{order.id}</h1>
          <p>{new Date(order.created_at).toLocaleString('fr-FR')}</p>
        </div>
        <button onClick={() => navigate('/admin/commandes')} className="admin-btn">
          ← Retour
        </button>
      </header>

      {/* Statut */}
      <div className="admin-card">
        <div className="admin-card__head">
          <h2>Statut de la commande</h2>
          <span className={`admin-badge admin-badge--${order.status || 'pending'}`}>
            {STATUS_LABELS[order.status] || order.status}
          </span>
        </div>
        <div className="admin-status-actions">
          {STATUSES.map(s => (
            <button
              key={s}
              className={`admin-chip ${order.status === s ? 'is-active' : ''}`}
              onClick={() => updateStatus(s)}
              disabled={saving || order.status === s}
            >
              {STATUS_LABELS[s]}
            </button>
          ))}
        </div>
      </div>

      {/* Infos cliente */}
      <div className="admin-grid-2">
        <div className="admin-card">
          <div className="admin-card__head"><h2>Cliente</h2></div>
          <p><strong>Nom :</strong> {order.user?.name || order.customer_name || '—'}</p>
          <p><strong>Téléphone :</strong> {order.customer_phone || order.user?.phone || '—'}</p>
          <p><strong>Email :</strong> {order.user?.email || '—'}</p>
        </div>

        <div className="admin-card">
          <div className="admin-card__head"><h2>Livraison</h2></div>
          <p><strong>Ville :</strong> {order.city || '—'}</p>
          <p><strong>Adresse :</strong> {order.address || '—'}</p>
          <p><strong>Pays :</strong> {order.country || 'Maroc'}</p>
          {order.note && <p><strong>Note :</strong> {order.note}</p>}
        </div>
      </div>

      {/* Articles */}
      <div className="admin-card">
        <div className="admin-card__head">
          <h2>Articles</h2>
          <span className="admin-badge admin-badge--neutral">{items.length} article(s)</span>
        </div>
        <table className="admin-table">
          <thead>
            <tr>
              <th>Produit</th>
              <th>Taille</th>
              <th>Qté</th>
              <th>Prix</th>
              <th>Total</th>
            </tr>
          </thead>
          <tbody>
            {items.map((it, i) => (
              <tr key={i}>
                <td>{it.product?.nom || it.nom || '—'}</td>
                <td>{it.size || '—'}</td>
                <td>{it.quantity}</td>
                <td>{parseFloat(it.prix || 0).toFixed(0)} DH</td>
                <td><strong>{(parseFloat(it.prix || 0) * it.quantity).toFixed(0)} DH</strong></td>
              </tr>
            ))}
          </tbody>
          <tfoot>
            <tr>
              <td colSpan="4" style={{ textAlign: 'right' }}>Total</td>
              <td><strong>{parseFloat(order.total || 0).toFixed(0)} DH</strong></td>
            </tr>
          </tfoot>
        </table>
      </div>

      {/* Actions */}
      <div className="admin-order-actions">
        <a
          href={`https://wa.me/${(order.customer_phone || '').replace(/\D/g, '')}?text=${encodeURIComponent(`Bonjour, concernant votre commande #${order.id} MADAD...`)}`}
          target="_blank"
          rel="noreferrer"
          className="admin-btn admin-btn--success"
        >
          📱 Contacter sur WhatsApp
        </a>
      </div>
    </div>
  );
}

export default AdminOrderDetail;